(function () {
    'use strict';

    function requestForProposalResponseStateService($rootScope, $log, requestForProposalResponseDataService, notifyService, sessionDataService) {
        var state = this;
        state.rfpResponse = {};

        // Wrapping it in the session call for now
        function update(rfpResponse, silent) {
            return sessionDataService.loadSession().then(function (sessionData) {
                return updateWithSessionData(rfpResponse, silent, sessionData);
            });
        }

        function updateWithSessionData(rfpResponse, silent, sessionData) {
            state.rfpResponse = rfpResponse;

            state.rfpResponse.ResponseContent.InformationParts.forEach(function (informationPart) {
                informationPart.Access = {
                    View: true,
                    Edit: false
                };
                if (informationPart.BlobSummaries) {
                    informationPart.BlobSummaries.forEach(function (blob) {
                        blob.Access = {
                            View: true,
                            Edit: false
                        };
                        blob.UploadedByCleanName = blob.UploadedByEntity
                            ? blob.UploadedByEntity.Contact.FirstName + ' ' + blob.UploadedByEntity.Contact.LastName
                            : 'N/A';
                    });
                }
            });

            var ownerEntityId = rfpResponse.EntityId;
            var accessingEntityId = rfpResponse.EntityId;

            if (ownerEntityId !== accessingEntityId) {
                if (sessionData.IsAdminEntity) {
                    state.rfpResponse.AccessLevel = "ProjectAdmin";
                }
                else {
                    $rootScope.$broadcast('response_error');
                    $log.error("You cannot access this rfp response");
                }
            }
            else {
                state.rfpResponse.AccessLevel = "ProjectOwner";
            }

            if (!silent) {
                requestForProposalResponseDataService.saveRequestForProposalResponse(state.rfpResponse).then(function (data) {
                    // TODO: Do we need anything here?
                }, function (error) {
                    // TODO: Handle potential concurrency issues
                    notifyService.notify('We could not save the changes to your rfp response.', true);
                });
            }

            $rootScope.$broadcast('rfpResponseUpdated');
            return state.rfpResponse;
        }

        function get() {
            return state.rfpResponse;
        }

        function removeInformationPart(informationPart, informationPartIndex) {
            state.rfpResponse.ResponseContent.InformationParts[informationPartIndex].IsRemoved = true;
            update(state.rfpResponse);
            notifyService.notify('You deleted ' + informationPart.Prompt);
        }

        function deleteUpload(informationPart, blobIndex) {
            var matchingInformationPart = state.rfpResponse.ResponseContent.InformationParts.find(function (part) {
                return part.Title === informationPart.Title;
            });

            matchingInformationPart.BlobSummaries[blobIndex].IsRemoved = true;
            update(state.rfpResponse);
            notifyService.notify('You deleted ' + matchingInformationPart.BlobSummaries[blobIndex].FileName);
        }

        function updateDocumentPrompt(document) {
            var informationPart = state.rfpResponse.ResponseContent.InformationParts.find(function (part) {
                return document.Title = part.Title;
            });

            informationPart.Prompt = document.Prompt;
            update(state.rfpResponse);
        }

        function syncQuestionSet(informationPartIndex, questionSet) {
            state.rfpResponse.ResponseContent.InformationParts[informationPartIndex] = questionSet;
            update(state.rfpResponse);
        }

        return {
            update: update,
            get: get,
            removeInformationPart: removeInformationPart,
            deleteUpload: deleteUpload,
            updateDocumentPrompt: updateDocumentPrompt,
            syncQuestionSet: syncQuestionSet
        };
    }

    requestForProposalResponseStateService.$inject = ['$rootScope', '$log', 'requestForProposalResponseDataService', 'notifyService', 'sessionDataService'];

    angular.module('ecap.requestForProposal').factory('requestForProposalResponseStateService', requestForProposalResponseStateService);
})();
